import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Dashboard from '../../components/DashboardTiles/Dashboards/Dashboard';
import PortalDashboard from '../../components/DashboardTiles/Dashboards/PortalDashboard';
class Landing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageSize: localStorage.getItem('homePageSize') != null ? parseInt(localStorage.getItem('homePageSize')) : 10,
    }
  }

  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== 'undefined') {
      // filter by text in the table or if it's a object, filter by key
      if (typeof content === 'object' && content !== null && content.key) {
        return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
      } else {
        return String(content).toLowerCase().includes(filter.value.toLowerCase());
      }
    }
    return true;
  };

  formatDate = (d) => {
    if (d == null || d === '' || parseInt(String(d).substring(0, 4)) <= 2000) return "";
    return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
  }

  setPageSize = (pageSize) => {
    this.setState({ pageSize: pageSize }, () => localStorage.setItem('homePageSize', pageSize))
  }

  render() {
    return (
      <Container className='text-left' fluid>
          <PortalDashboard {...this.props} />
          <Dashboard {...this.props} />
      </Container>
    );

  }
}

export default Landing;
